/**
 * Hydrate PDP product rating from workshop reviews API aggregate (avg_rating, review_count).
 */
(function () {
  'use strict';

  function formatScore(value) {
    var n = Number(value);
    if (!Number.isFinite(n)) return '';
    return n.toFixed(2);
  }

  function reviewLabel(count) {
    var n = Number(count);
    if (!Number.isFinite(n) || n < 0) n = 0;
    n = Math.round(n);
    return n === 1 ? '1 Review' : n + ' Reviews';
  }

  function resolveApiBase(root) {
    var fromRoot = root.getAttribute('data-api-base-url');
    if (fromRoot) return fromRoot.replace(/\/$/, '');
    var section = document.querySelector('.workshop-reviews[data-api-base-url]');
    if (section) {
      var fromSection = section.getAttribute('data-api-base-url');
      if (fromSection) return fromSection.replace(/\/$/, '');
    }
    return 'https://adapter.aogen.com.au';
  }

  function buildReviewsUrl(apiBase, shopDomain, workshopType) {
    var params = new URLSearchParams();
    params.set('shop_domain', shopDomain);
    if (workshopType) params.set('workshop_type', workshopType);
    params.set('status', 'approved');
    params.set('include_google', 'true');
    params.set('include_site', 'true');
    params.set('limit', '1');
    params.set('offset', '0');
    return apiBase + '/api/public/reviews?' + params.toString();
  }

  function applyAggregate(root, avg, count, scaleMax) {
    var scoreEl = root.querySelector('[data-amc-rating-score]');
    var countEl = root.querySelector('[data-amc-rating-count]');
    var fillEl = root.querySelector('[data-amc-rating-fill]');
    if (scoreEl) scoreEl.textContent = formatScore(avg);
    if (countEl) countEl.textContent = reviewLabel(count);
    if (fillEl && Number.isFinite(avg) && scaleMax > 0) {
      fillEl.style.width = 'calc(' + avg + ' / ' + scaleMax + ' * 100%)';
    }
    root.classList.add('is-hydrated');
    root.setAttribute(
      'aria-label',
      formatScore(avg) + ' out of ' + scaleMax + ' stars, ' + reviewLabel(count)
    );
  }

  function initRoot(root) {
    var workshopType = String(root.getAttribute('data-workshop-type') || '').trim();
    if (!workshopType) return;

    var shopDomain =
      String(root.getAttribute('data-shop-domain') || '').trim() ||
      String(root.getAttribute('data-shop-domain-fallback') || '').trim();
    if (!shopDomain) return;

    var scaleMax = Number(root.getAttribute('data-scale-max') || 5);
    if (!Number.isFinite(scaleMax) || scaleMax <= 0) scaleMax = 5;

    var apiBase = resolveApiBase(root);
    fetch(buildReviewsUrl(apiBase, shopDomain, workshopType), { credentials: 'omit' })
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(new Error('reviews fetch failed'));
      })
      .then(function (payload) {
        var aggregate = payload && payload.aggregate ? payload.aggregate : null;
        if (!aggregate) return;
        var avg = Number(aggregate.avg_rating);
        if (!Number.isFinite(avg)) return;
        var count = aggregate.review_count != null ? aggregate.review_count : aggregate.total;
        applyAggregate(root, avg, count, scaleMax);
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-amc-product-rating]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
